module.exports = __webpack_public_path__ + "img/SN.4a5760c1.svg";